export { cloudStoragePlugin } from './plugin.js'
